import type { Ref } from 'react';
import { Textarea as KitTextarea } from '@immo/ui-kit';

type TextareaProps = {
  // React 19 passes `ref` as an ordinary prop to function components — declared
  // so a form can move focus to the field a refusal is about.
  readonly ref?: Ref<HTMLTextAreaElement>;
  readonly id: string;
  readonly value: string;
  readonly placeholder?: string;
  readonly rows?: number;
  readonly maxLength?: number;
  readonly disabled?: boolean;
  readonly invalid?: boolean;
  readonly onChange: (value: string) => void;
  readonly 'aria-describedby'?: string | undefined;
};

/**
 * The customer app's controlled textarea — a thin adapter over the kit's
 * `Textarea` (promoted in IMM-981), which carries the look this file used to
 * spell out itself. What stays here is the app's calling convention: a value in,
 * a string out, three rows, and no resize handle on customer forms.
 */
export function Textarea({
  ref,
  id,
  value,
  placeholder,
  rows = 3,
  maxLength,
  disabled = false,
  invalid = false,
  onChange,
  'aria-describedby': ariaDescribedby,
}: TextareaProps) {
  return (
    <KitTextarea
      ref={ref}
      id={id}
      value={value}
      placeholder={placeholder}
      rows={rows}
      maxLength={maxLength}
      disabled={disabled}
      invalid={invalid}
      aria-describedby={ariaDescribedby}
      onChange={(event) => onChange(event.target.value)}
      className="resize-none"
    />
  );
}
